import React from 'react';

const TransactionIdLightIcon = ({height="43", width="42"}) => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 42 43" fill="none">
      <rect opacity="0.3" y="0.5" width="42" height="42" rx="10" fill="#1C1C1C" fillOpacity="0.2"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M31 22.4524V14.5452L23.0928 14.5452L23.0928 16.3902L27.8371 16.3902L21.7749 22.4524L23.0928 23.7703L29.155 17.7081V22.4524H31ZM11 19.5475V27.4548H18.9072V25.6098H14.1629L20.2251 19.5475L18.9072 18.2297L12.845 24.2919V19.5475H11Z" fill="#454545"/>
    </svg>
  );
};

export default TransactionIdLightIcon;
